export const setColor = {
  whiteColor: '#fff',
  primaryColor: '#00415e',
  secondaryColor: '#bbcf00',
};

export const setRem = (number = 16) => {
  return `${number / 16}rem`;
};
